import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
// TODO:Spartacus - // TODO:Spartacus - Variable organizationTranslations has been removed and is no longer part of the public API.
import {
   organizationTranslationChunksConfig,
   organizationTranslationsEn
} from '@spartacus/organization/administration/assets';
import {
   AdministrationRootModule,
   ORGANIZATION_ADMINISTRATION_FEATURE,
} from '@spartacus/organization/administration/root';

@NgModule({
   declarations: [],
   imports: [AdministrationRootModule],
   providers: [
      provideConfig(<CmsConfig>{
         featureModules: {
            [ORGANIZATION_ADMINISTRATION_FEATURE]: {
               module: async () => import('@spartacus/organization/administration').then(m => m.AdministrationModule),
            },
         },
      }),
      provideConfig(<I18nConfig>{
         i18n: {
            chunks: organizationTranslationChunksConfig,
            resources: {
               en: organizationTranslationsEn,
            },
         },
      }),
   ],
})
export class OrganizationAdministrationFeatureModule {}
